import React from 'react';
import { useGetCaraWorkspaceArtifactPrintsLegacyLookQuery } from '~/api/graphql';

/**
 * Whether the open document version prints its template's Legacy look with no design, which
 * names the Design menu's choice of none. Read from the cache first, and asked again for a version
 * the last answer did not cover, such as one a design switch just made.
 */
export const useDocumentPrintsLegacyLook = (props: {
  workspaceId: string;
  artifactId: string;
  version: number;
  skip: boolean;
}): boolean => {
  const { data, refetch } = useGetCaraWorkspaceArtifactPrintsLegacyLookQuery({
    variables: { workspaceId: props.workspaceId, artifactId: props.artifactId },
    skip: props.skip,
    fetchPolicy: 'cache-and-network'
  });
  const versions = data?.caraWorkspaceArtifact?.versions;
  const answer = versions?.find((each) => each.version === props.version);
  const unanswered = !props.skip && !!versions && !answer;

  // Once per version, so a version the server does not list is not asked about forever.
  const askedAgain = React.useRef<string | null>(null);
  const key = `${props.artifactId}:${props.version}`;
  React.useEffect(() => {
    if (!unanswered || askedAgain.current === key) return;
    askedAgain.current = key;
    void refetch();
  }, [unanswered, key, refetch]);

  return !props.skip && !!answer?.printsLegacyLook;
};
